import React, {useRef} from "react"

export type PageLoadLifetimeStoreReturnType<T> = [React.MutableRefObject<T | null>, (prevValue: T) => void]

/**
 * Hook for abstracting a variable storage for the lifetime of a page load.
 * @returns an array with the variable value and its setter function @type {PageLoadLifetimeStoreReturnType<T>}
 */
export const usePageloadLifetimeStore = <T>(defaultValue: T | null = null): PageLoadLifetimeStoreReturnType<T> => {
    const value = useRef<T | null>(defaultValue)
    const setter = React.useCallback((prevValue: T) => {
        value.current = prevValue
    }, [])
    return [value, setter]
}
